import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=84a8ae7e&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a8ae7e",
  null
  
)

export default component.exports